import React from "react";
import DocumentTitle from "react-document-title";
import {Switch} from "react-router-dom";
import {Redirect, Route} from "react-router";
import {DefaultRoutes, QuestionsRoutes} from "../../routes";
import {Questions} from "../../modules/Questions";
import {QuestionsRenderPage} from "./QuestionsRenderPage";
import {QuestionEdit} from "../QuestionEdit";
import QuestionCreate from "../QuestionCreate/QuestionCreate";
import {QuestionFilesPage} from "../QuestionFilesPage";
import {FeatureAppearance} from "../../modules/FeatureAppearance";

export default function QuestionsPage() {
	return (
		<DocumentTitle title={"Задачи - Mindset.Digital"}>
			<Switch>
				<Route exact path={`/${DefaultRoutes.questions}`} component={Questions} />
				<Route path={`/${QuestionsRoutes.files}`} render={() => <RenderPage component={QuestionFilesPage} />} />
				<Route exact path={`/${QuestionsRoutes.fullRender}`} component={QuestionsRenderPage} />
				<Route path={`/${QuestionsRoutes.create}`} render={() => <RenderPage component={QuestionCreate} />} />
				<Route path={`/${QuestionsRoutes.edit}`} render={() => <RenderPage component={QuestionEdit} />} />
			</Switch>
		</DocumentTitle>
	);
}

function RenderPage({ component: Component }: { component: React.ComponentType }) {
	return (
		<FeatureAppearance feature={["questions.questions.any.create", "questions.questions.any.update"]}>
			{(featureExist) => {
				return featureExist
					? (
						<Component />
					)
					: <Redirect to={"/page404"} />
			}}
		</FeatureAppearance>
	)
}